import App from "./app.tsx";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import "./index.css";
import { Provider } from "react-redux";
import { Analytics } from "@vercel/analytics/react";
import store from "./store/store.ts";
import { BrowserRouter } from "react-router-dom";
import ReactDOM from "react-dom/client";
import { AppProvider } from "./middleware.tsx";

const Root: React.FC = () => {
  return (
    <BrowserRouter>
      <ThemeProvider theme={createTheme()}>
        <Provider store={store}>
          <AppProvider>
            <App />
            <Analytics />
          </AppProvider>
        </Provider>
      </ThemeProvider>
    </BrowserRouter>
  );
};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(<Root />);
